/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { useEffect, useState } from 'react'; // Add useState import
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

import {
    StyledChatBarItems,
    StyledChatBarItemsContainer,
    StyledChatBarNew,
} from './ChatBarNew.styled';

import ChatBarItem from './components/ChatBarItem/ChatBarItem';
import api from 'api';

export default function ChatBarNew({
    activeChatGroupId,
    onChatItemClick,
}: {
    onChatItemClick: (chatGroupId: string, chatName: string) => void;
    activeChatGroupId: string;
}) {
    const user_id = useSelector((state: RootState) => state.user.entity.id);
    const [chatGroups, setChatGroups] = useState<any>([]);
    const activeChatId = parseInt(activeChatGroupId, 10);

    useEffect(() => {
        const getChatGroups = async () => {
            try {
                const res = await api.chatNew.get_chat_groups();
                setChatGroups(res.data);
            } catch (error) {
                console.error(error);
            }
        };
        getChatGroups();
    }, []);

    return (
        <StyledChatBarNew>
            {/* ... */}
            <StyledChatBarItemsContainer>
                <StyledChatBarItems>
                    {chatGroups.length === 0 ? (
                        <p>No chats yet</p>
                    ) : (
                        chatGroups.map((chatGroup: any) => {
                            const chatTitle =
                                chatGroup.users_info.find((user: any) => user.id !== user_id)
                                    ?.name || '';

                            return (
                                <ChatBarItem
                                    key={chatGroup.id}
                                    active={chatGroup.id === activeChatId}
                                    title={chatTitle}
                                    lastMessage={chatGroup.last_message}
                                    onClick={() => onChatItemClick(chatGroup.id, chatTitle)}
                                    avatar={
                                        chatGroup.users_info.find(
                                            (user: any) => user.id !== user_id
                                        )?.picture || null
                                    }
                                />
                            );
                        })
                    )}
                </StyledChatBarItems>
            </StyledChatBarItemsContainer>
        </StyledChatBarNew>
    );
}
